<template>
  <el-card>
    <template v-slot:header>
      <h4>{{ $t('基础资料') }}</h4>
    </template>

    <div class="content">
      <div>
        <img class="user-avatar" :src="avatar" />
      </div>

      <el-descriptions>
        <el-descriptions-item :label="$t('编号')">{{ detail.num }}</el-descriptions-item>
        <el-descriptions-item :label="$t('昵称')">{{ detail.nickname }}</el-descriptions-item>
        <el-descriptions-item :label="$t('性别')">
          <dict-text :status="detail.sex" dict-flag="USER_SEX" />
        </el-descriptions-item>
        <el-descriptions-item :label="$t('手机号码')">{{ detail.phone }}</el-descriptions-item>
        <el-descriptions-item :label="$t('邮箱')">{{ detail.email }}</el-descriptions-item>
        <el-descriptions-item :label="$t('QQ')">{{ detail.qq }}</el-descriptions-item>
        <el-descriptions-item :label="$t('出生日期')">{{ detail.birthday | formatTime }}</el-descriptions-item>
        <el-descriptions-item :label="$t('注册时间')">{{ detail.createTime | formatDate }}</el-descriptions-item>
        <el-descriptions-item :label="$t('用户状态')">
          <dict-text :status="detail.userBandStatus" dict-flag="AN_USER_STATUS" />
        </el-descriptions-item>
        <el-descriptions-item :label="$t('会员等级')">{{ detail.vipLevel }}</el-descriptions-item>
        <el-descriptions-item :label="$t('会员有效时间')" :span="2">{{ detail.startTime | formatTime }} - {{detail.endTime | formatTime}}</el-descriptions-item>
        <el-descriptions-item :label="$t('当前会员状态')">{{ detail.num }}</el-descriptions-item>
        <el-descriptions-item :label="$t('使用等级')">{{ detail.userLevel }}</el-descriptions-item>
        <el-descriptions-item :label="$t('发布等级')">{{ detail.releaseLevel }}</el-descriptions-item>
      </el-descriptions>
    </div>
  </el-card>
</template>

<script>
import DictText from "@/components/dict/DictText";
export default {
  name: "UserInfo",
  components: {DictText},
  props: {
    detail: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    avatar() {
      const {portrait} = this.detail;
      if(!portrait) return null;
      return this.$api.file.downloadImg + portrait;
    }
  }
}
</script>

<style scoped>

.user-avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}

.content {
  display: flex;
}

.el-descriptions {
  margin-left: 40px;
  max-width: 1000px;
}

</style>
